<script>
export default {
  props: {
    error: { type: Boolean, default: false },
    confirmationText: { type: String, default: '' },
  },
  data() {
    return {
      animationStatus: 0,
    };
  },
  methods: {
    confirm() {
      if (this.animationStatus != 2) {
        this.animationStatus = 2;
        this.$emit('clicked');
      }
    },
  },
  computed: {
    confirmationTextComputed() {
      if (this.confirmationText != null && this.confirmationText.length > 0) {
        return this.confirmationText;
      }

      return this.$t('general.areYouSure');
    },
  },
  watch: {
    error(err) {
      if (err) {
        this.animationStatus = 3;
      }
    },
  },
};
</script>

<template>
  <div class="flipBtnWrapper" :class="{ flipped: animationStatus > 0 }">
    <div class="flipBtn">
      <div
        class="flipBtn_face flipBtn_front middle-text custom-inventory-shadow"
        @click="animationStatus = 1"
      >
        <slot></slot>
      </div>

      <div
        class="flipBtn_face flipBtn_back middle-text custom-inventory-shadow"
        :style="{
          backgroundColor:
            animationStatus == 2
              ? '#6fd9b1'
              : animationStatus == 3
              ? '#f46a6a'
              : '#34c38f',
        }"
        @click="confirm"
      >
        <div>
          <i
            v-if="animationStatus == 2"
            class="bx bx-loader-alt bx-spin"
            style="font-size: 1.6em; font-weight: 600"
          >
          </i>
          <span v-else-if="animationStatus == 3">
            {{ $t('errors.operationFailedTryAgain') }}
          </span>
          <span v-else>{{ confirmationTextComputed }}</span>
        </div>
        <div
          v-if="animationStatus < 2"
          class="flipBtn_cancel middle-text"
          @click.stop="animationStatus = 0"
        >
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.flipBtnWrapper {
  width: 100%;
  height: 40px;
  position: relative;
  cursor: pointer;
  user-select: none;
}

.flipBtn {
  transition: transform 1s;
  transform-style: preserve-3d;
}

.flipBtn,
.flipBtn_face {
  width: 100%;
  height: 100%;
  position: absolute;
  color: white;
  border-radius: 5px;
}

.flipBtnWrapper.flipped .flipBtn {
  transform: rotateX(180deg);
}

.flipBtn_front {
  background-color: #74788d;
  backface-visibility: hidden;
  transform: translateZ(1px);
}
.flipBtn_front:hover {
  background-color: #696c81;
}

.flipBtn_back {
  transform: translateZ(-1px);
  transform: rotateX(180deg);
  backface-visibility: hidden;
  overflow: hidden;
}

.flipBtn_cancel {
  font-size: 2em;
  background-color: #f46a6a;
  border-radius: 50px 0 0 50px;
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  padding-left: 10px;
  width: 120px;
}

.middle-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
